import React, { useEffect, useState, useRef } from 'react';
import { Box } from '@rsos/base-components';
import {
  createCompassWidget,
  COMPASS_WIDGET_TITLE,
} from '@rsos/maps/providers/esri/widgets/createCompassWidget';
import { trackUseCompassNavigation } from '../../../../../../../../../apps/emergency_data/src/components/JurisdictionView/Map/gainsight/gisTrackings';
import type { CompassButtonProps, CompassWidget } from './CompassButton.types';

const CompassButton: React.FC<CompassButtonProps> = ({ mapInstance }) => {
  const [, setCompassWidget] = useState<CompassWidget | null>(null);
  const compassContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mapInstance?.view) {
      const mapView = mapInstance.view;
      const existingCompassWidget = mapView.ui.find(
        COMPASS_WIDGET_TITLE,
      ) as CompassWidget;

      if (existingCompassWidget) {
        existingCompassWidget.visible = true;
        setCompassWidget(existingCompassWidget);

        // Add click tracking to existing compass widget
        const compassContainer = existingCompassWidget.container;
        if (compassContainer instanceof HTMLElement) {
          const existingListener = compassContainer.dataset.compassTracked;
          if (!existingListener) {
            compassContainer.addEventListener('click', () => {
              trackUseCompassNavigation({ action: 'reset_north' });
            });
            compassContainer.dataset.compassTracked = 'true';
          }
        }
      } else {
        try {
          const newCompassWidget = createCompassWidget({
            mapView,
          });

          mapView.ui.add(newCompassWidget);
          newCompassWidget.when(() => {
            newCompassWidget.visible = true; // Always visible
            const widgetContainer = compassContainerRef.current;
            const compassContainer = newCompassWidget.container;

            if (
              widgetContainer &&
              compassContainer instanceof HTMLElement &&
              !widgetContainer.contains(compassContainer)
            ) {
              compassContainer.style.zIndex = '2';
              widgetContainer.appendChild(compassContainer);

              // Add click event listener for compass tracking
              compassContainer.addEventListener('click', () => {
                trackUseCompassNavigation({ action: 'reset_north' });
              });
            }
            setCompassWidget(newCompassWidget);
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error creating compass widget:', error);
        }
      }
    }
  }, [mapInstance]);

  return (
    <Box
      ref={compassContainerRef}
      id="compass-container"
      width="32px"
      height="32px"
      backgroundColor="background"
      borderRadius="5px"
      mb={2}
    ></Box>
  );
};

export default CompassButton;
